import axios from "axios";
import { baseURL } from "../config/config";

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "X-DTS-SCHEMA": "https://project-lock.universal-service.in",
    "Content-Type": "application/json",
  },
});

export default axiosInstance;